module.exports = __webpack_public_path__ + "static/media/mrpoopy.ee4f3f86.png";